import { PanelRow, ToggleControl, FormTokenField, TextControl } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { useState, useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n'

export default () => {

    const allData = useSelect((select) => {
        return select('WPTravel/TripEdit').getAllStore()
    }, []);
    
    const {is_fixed_departure} = allData
    const { updateTripData } = dispatch('WPTravel/TripEdit');
    // console.log( allData );
    let cuttOffTime = 'undefined' != typeof allData.cuttOffTime ? allData.cuttOffTime : 0
    if ( is_fixed_departure) {

        return <>
        <PanelRow>
                <label>{__('Cut off Time (in hours)', 'wp-travel')}</label>
                <TextControl
                    value={cuttOffTime}
                    type="number"
                    help="Please set cut off time according to UTC time."
                    min="0"
                    autoComplete="off"
                    onChange={(hours) => {
                        updateTripData({
                            ...allData,
                            cuttOffTime:  hours
                        })
                    }}
                />
            </PanelRow>
        
        </>
    }
    return <></>
}